import { render, staticRenderFns } from "./ImageChangeWeightModal.vue?vue&type=template&id=563f206b&scoped=true&"
import script from "./ImageChangeWeightModal.vue?vue&type=script&lang=js&"
export * from "./ImageChangeWeightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f206b",
  null
  
)

export default component.exports